import { render, staticRenderFns } from "./ReferenceFilter.vue?vue&type=template&id=04fb4948&scoped=true&"
import script from "./ReferenceFilter.vue?vue&type=script&lang=js&"
export * from "./ReferenceFilter.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceFilter.vue?vue&type=style&index=0&id=04fb4948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb4948",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
